module.exports = __webpack_public_path__ + "img/prize-banner-rugby.25ef5819.webp";